module.exports = __webpack_public_path__ + "static/img/1037_small.99a5664.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1037_small.png
// module id = 8eH7
// module chunks = 1